import { render, staticRenderFns } from "./DocumentImageSwapper.vue?vue&type=template&id=3356f00a&scoped=true&"
import script from "./DocumentImageSwapper.vue?vue&type=script&lang=ts&"
export * from "./DocumentImageSwapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3356f00a",
  null
  
)

export default component.exports